"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WEIGHTING_BAR_CATEGORY_KEY = 'base';
exports.WEIGHTING_BAR_COMPONENT_KEY = 'weightingBar';